import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'

import useTranslations from '../../../../../i18n/useTranslations'
import Divider from '../../../../../ui/components/divider'

import styles from '../../styles'

const ReferenceAndUpdateDate = ({
  clientReference,
  shippingStatusDatetime,
}) => {
  const t = useTranslations()

  return (
    <Box sx={styles.referenceAndLastUpdateContainer}>
      {clientReference ? (
        <Box>
          <Divider variant="middle" sx={styles.divider} />
          <Typography variant="body2">{t('noun:clientReference')}</Typography>
          <Typography variant="body2">
            <strong>{clientReference}45678905G</strong>
          </Typography>
        </Box>
      ) : null}
      {shippingStatusDatetime?.length ? (
        <Box>
          <Divider variant="middle" sx={styles.divider} />
          <Typography variant="body2">{t('noun:last-update')}</Typography>
          <Typography variant="body2">
            <strong>{shippingStatusDatetime[0]}</strong>
          </Typography>
        </Box>
      ) : null}
    </Box>
  )
}

ReferenceAndUpdateDate.propTypes = {
  clientReference: PropTypes.string,
  shippingStatusDatetime: PropTypes.array,
}

export default ReferenceAndUpdateDate
